import { ProjectStakeholderListState } from ".";
import { INIT_ERROR_RESULT_DATA } from "../../../util";

const displayColumn = [
  { label: "Primary", value: "primFlg" },
  { label: "Team Code", value: "teamCd" },
  { label: "Role Name", value: "roleCd" },
  { label: "User ID", value: "userId" },
  { label: "User Name", value: "userName" },
  { label: "Mail Address", value: "mlAdrs" },
  { label: "Note", value: "stkhldrNote" },
];

export const ProjectStakeholderListInitialState: ProjectStakeholderListState = {
  isShow: false,
  reqReload: false,
  saved: [],
  edited: [],
  codes: {
    inDefCommonFlagTypeCd: [],
    roleCdList: [],
  },
  displayColumn: displayColumn,
  displayFilter: "1",
  fromActionList: false,
  pjtId: "",
  pjtTypeCd: "",
  updateDateTime: "",
  status: {
    invalidList: [],
    invalidRecordList: [],
    isSaved: false,
  },
  spreadsheet: {
    tmplateRow: {
      ...INIT_ERROR_RESULT_DATA,
      isAddRow: false,
      stkhldrId: "",
      primFlg: "Y",
      roleCd: "",
      roleName: "",
      teamCd: "",
      userId: "",
      userName: "",
      mlAdrs: "",
      stkhldrNote: "",
    },
  },
};
